import React from 'react';
import { MapPin, Calendar } from 'lucide-react';
import PageLayout from './PageLayout';
import '../styles/Dashboard.Common.css';

const Dashboard = () => {
  return (
    <PageLayout className="dashboard-page">
      {/* Welcome Section */}
      <div className="dashboard-welcome-section">
        <div className="dashboard-welcome-card">
          <h2 className="dashboard-welcome-title">
            Welcome to your Sports Dashboard!
          </h2>
          <p className="dashboard-welcome-description">
           Manage venues, schedule games, and keep track of all your sporting activities!
          </p>
        </div>
      </div>

      {/* Quick Actions Grid */}
      <div className="dashboard-quick-actions-grid">
        <div className="dashboard-action-card">
          <div className="dashboard-action-icon dashboard-grounds-icon">
            <MapPin size={28} />
          </div>
          <div className="dashboard-action-content">
            <h3>Manage Venues</h3>
            <p>View and create venues for games</p>
            <a href="/ViewGrounds" className="dashboard-action-link">Get Started →</a>
          </div>
        </div>

        <div className="dashboard-action-card">
          <div className="dashboard-action-icon dashboard-schedule-icon">
            <Calendar size={28} />
          </div>
          <div className="dashboard-action-content">
            <h3>Schedule Events</h3>
            <p>Plan and organize upcoming games</p>
            <a href="/ViewSchedule" className="dashboard-action-link">Get Started →</a>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Dashboard;